/**
 * Vérifie si une chaine de caractères est vide
 * @param value - string - Chaine à vérifier
 */
export const checkIsNotEmpty = (value: string) => {
  if (!value) {
    return false;
  }

  if (value && value.trim() === "") {
    return false;
  }
  return true;
};
